/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_User_Profile_DataInputs */

const en_no_user_profile_data = /** @type {(inputs: No_User_Profile_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Matching Week profile data available.`)
};

const de_no_user_profile_data = /** @type {(inputs: No_User_Profile_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Matching-Week-Profildaten vorhanden.`)
};

/**
* | output |
* | --- |
* | "No Matching Week profile data available." |
*
* @param {No_User_Profile_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_user_profile_data = /** @type {((inputs?: No_User_Profile_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_User_Profile_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_user_profile_data(inputs)
	return en_no_user_profile_data(inputs)
});